export default {
    namespaced: true,
    state: {
        customer_id: null,
        login_name: null,
        name: '',
        email:'',
        tel: '',
        admin: 0,
        backTo: '',
    },
    getters: {
        customer_id(state) {
            return state.customer_id
            // return state.scenarios.find((s) => {s.id == id})
        },
        login_name(state) {
            return state.login_name
            // return state.scenarios.find((s) => {s.id == id})
        },
        name(state) {
            return state.name
            // return state.scenarios.find((s) => {s.id == id})
        },
        email(state) {
            return state.email
            // return state.scenarios.find((s) => {s.id == id})
        },
        tel(state) {
            return state.tel
            // return state.scenarios.find((s) => {s.id == id})
        },
        admin(state) {
            return state.admin == 1
            // return state.scenarios.find((s) => {s.id == id})
        },
        dump(state) {
            return state
        },
        backTo(state) { return state.backTo },
    },
    mutations: {
        customer_data: function (state, payload) {
            state.customer_id = payload.customer_id
            state.login_name = payload.login_name
            state.name = payload.name
            state.email = payload.email
            state.tel = payload.tel
            state.admin = payload.admin
        },
        clear: function(state) {
            state.customer_id = null
            state.login_name = null
            state.name = ''
            state.email = ''
            state.tel = ''
        },
        setBackTo: function (state, backTo) {
            state.backTo = backTo
        },
    },
    actions: {
    },
}
